module.exports = __webpack_public_path__ + "static/logo20-45aa7033ba0ccec273cb0257152cb923.png";